import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=4e60bd43&scoped=true&"
import script from "./icon.vue?vue&type=script&lang=ts&"
export * from "./icon.vue?vue&type=script&lang=ts&"
import style0 from "./icon.vue?vue&type=style&index=0&id=4e60bd43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e60bd43",
  null
  
)

export default component.exports